export default {
	setGlobalLoading: (state, value) => (state.globalLoading = value),
	setUsers: (state, users) => (state.users = users),
	setProfile: (state, profile) => (state.profile = profile),
	setToken: (state, token) => (state.token = token),
	setRefreshToken: (state, refreshToken) => (state.refreshToken = refreshToken),
	setMessage: (state, message) => (state.message = message),
	setUserSharingEmails: (state, emails) => (state.userSharingEmails = emails),
	setSharingWithMeEmails: (state, emails) => (state.sharingWithMeEmails = emails),
	setLoading: (state, loading) => (state.loading = loading),
	setAvatar: (state, avatar) => (state.profile.img = avatar),
	setInvoiceByUser: (state, invoice) => (state.invoice = invoice),
	setUserProfile: (state, userProfile) => (state.profileUser = userProfile),
};
